import { render, staticRenderFns } from "./batchad-table.vue?vue&type=template&id=7ac57517&scoped=true"
import script from "./batchad-table.vue?vue&type=script&lang=js"
export * from "./batchad-table.vue?vue&type=script&lang=js"
import style0 from "./batchad-table.vue?vue&type=style&index=0&id=7ac57517&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac57517",
  null
  
)

export default component.exports